import React, { useEffect } from 'react'
import Whitepaperbanner from './whitepaperbanner/Whitepaperbanner'
import Whitepaperoverview from './whitepaperoverview/Whitepaperoverview'
import Whitepapertopics from './whitepapertopic/Whitepapertopics'
import Getapp from './getapp/Getapp'
import Footer from '../landing/footer/Footer'

const Whitepaperlanding = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500); // Adjust delay as needed (500ms)
  
    return () => clearTimeout(timer); // Cleanup to prevent memory leaks
  }, []);
  return (
    <>
    <Whitepaperbanner/>
    <Whitepaperoverview/>
    <Whitepapertopics/>
    <Getapp/>
    <Footer/>
    </>
  )
}

export default Whitepaperlanding